import React, { ReactNode } from 'react';
import { Page } from 'components';
import { Flex, Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

interface ErrorPageProps {
  title?: string;
  message?: string | ReactNode;
  action?: Function;
  actionMessage?: string;
}

export default function ErrorPage(props: ErrorPageProps) {
  const { title, message, action, actionMessage } = props;
  const { t } = useTranslation();
  const pageTitle = title ?? (t('error:hero') as string);
  return (
    <Page title={pageTitle}>
      <Flex vertical justify="center" align="center" className="grow">
        <Flex vertical gap="small" className="max-w-xl">
          <Typography.Title className="text-center">
            {pageTitle}
          </Typography.Title>
          <Typography.Paragraph className="text-center whitespace-pre-line">
            {message || t('error:description')}
          </Typography.Paragraph>
          <div className="text-center">
            <Button
              type="primary"
              onClick={() => (action ? action() : location.reload())}
            >
              {actionMessage || t('error:action')}
            </Button>
          </div>
        </Flex>
      </Flex>
    </Page>
  );
}
